<!--
 * @Author: wangjx
 * @LastEditors: wangjx
 * @Date: 2021-10-18 09:27:53
 * @LastEditTime: 2021-10-21 17:13:39
 * @Description: file content
-->
<script>
export default {
  created() {
    const { params, query } = this.$route;
    const { path } = params;
    this.$router.replace({ path: `/${path}`, query });
  },
  render(h) {
    return h(); // avoid warning message
  }
};
</script>
